import { IComparator, NameValue } from '@infodata-group/inf-commons';
import { Period } from './period';
import dayjs from 'dayjs';
import { PeriodFactory } from './factory/period-factory';

export class Exercise implements IComparator {
  public code: number;
  public currency: string;
  public currencyManagement: string[];
  public dateStart: Date;
  public dateEnd: Date;
  public exerciseClosure: NameValue;
  public exerciseClosureRem: string;
  public periods: Period[] = [];

  toString(): string {
    return this.code + '';
  }

  public serialize(): any {
    return {
      Code: this.code,
      Currency: this.currency,
      CurrencyManagement: this.currencyManagement,
      DateBegin: dayjs(this.dateStart).format('DD.MM.YYYY'),
      DateEnd: dayjs(this.dateEnd).format('DD.MM.YYYY'),
      ExerciceClosure: this.exerciseClosure,
      ExerciceClosureRem: this.exerciseClosureRem,
      Periods: this.periods.map((p) => p.serialize()),
    };
  }

  convert(item: any): Exercise {
    const exercise = new Exercise();
    exercise.code = item.Code;
    exercise.currency = item.Currency;
    exercise.currencyManagement = item.CurrencyManagement;
    exercise.dateStart = dayjs(item.DateBegin, 'DD.MM.YYYY').toDate();
    exercise.dateEnd = dayjs(item.DateEnd, 'DD.MM.YYYY').toDate();
    exercise.exerciseClosure = item.ExerciceClosure;
    exercise.exerciseClosureRem = item.ExerciceClosureRem;
    const factory = new PeriodFactory();
    for (const p of item.Periods) {
      exercise.periods.push(factory.build(p));
    }
    return exercise;
  }

  compare(comparant: any): number {
    return this.code === comparant.code ? 0 : 1;
  }
}
